import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { QuillEditorComponent, QuillModules } from 'ngx-quill';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-comment-edit-modal',
    standalone: true,
    imports: [FormsModule, QuillEditorComponent, TranslatePipe],
    template: `
        <div class="modal-header panel-heading">
            <h2 class="modal-title">{{ "labels.comment" | translate }}</h2>
            <button type="button" class="close" (click)="onClose()" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <quill-editor [(ngModel)]="value" format="html" [modules]="modules" [styles]="editorStyles" class="w-100"></quill-editor>
        </div>
        <div class="modal-footer">
            <button class="btn btn-primary ml-3" (click)="onSave()">{{ "labels.save" | translate }}</button>
            <button class="btn btn-danger ml-3" (click)="onClose()">{{ "labels.cancel" | translate }}</button>
        </div>
    `
})
export class CommentEditModalComponent implements OnInit {
    @Input() initialValue: string = '';

    value = '';

    editorStyles = { height: '300px' };

    modules: QuillModules = {
        toolbar: [
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'],
        ],
    };

    constructor(private activeModal: NgbActiveModal) {}

    ngOnInit(): void {
        this.value = this.initialValue ?? '';
    }

    onSave(): void {
        this.activeModal.close(this.value);
    }

    onClose(): void {
        this.activeModal.dismiss();
    }
}
